import React from 'react';
import Select from 'react-select';
import { getTheme } from '../../helpers/select.theme';
import { customStyles } from '../../helpers/select.custom';

const visibilityOptions = [
  { value: 'only_member_portal', label: 'Member Portal Only', abbreviation: 'MEM' },
  { value: 'only_retiree_portal', label: 'Medicare Portal Only', abbreviation: 'MED' },
  { value: 'both_portals', label: 'Both Portals', abbreviation: 'BOT' }
];

const PortalVisibilitySelect = ({
  value,
  onChange,
  disabled = false,
  compact = false,
  className = '',
  placeholder = 'Select portal visibility...'
}) => {
  // Get the selected option object from the value
  const getSelectedOption = (val) => {
    return visibilityOptions.find(option => option.value === (val || 'only_member_portal')) || visibilityOptions[0];
  };

  // Shared style to prevent text truncation of abbreviations
  const singleValueNoTruncation = (provided) => ({
    ...provided,
    overflow: 'visible',
    textOverflow: 'clip'
  });

  // Enhanced styles with no text truncation
  const enhancedStyles = {
    ...customStyles,
    singleValue: singleValueNoTruncation
  };

  // Compact styles for table view
  const compactStyles = {
    ...customStyles,
    control: (provided) => ({
      ...provided,
      minHeight: '32px',
      height: '32px'
    }),
    valueContainer: (provided) => ({
      ...provided,
      height: '32px',
      padding: '0 8px'
    }),
    input: (provided) => ({
      ...provided,
      margin: '0px'
    }),
    indicatorsContainer: (provided) => ({
      ...provided,
      height: '32px'
    }),
    singleValue: singleValueNoTruncation
  };

  return (
    <Select
      theme={(theme) => getTheme(theme)}
      styles={compact ? compactStyles : enhancedStyles}
      value={getSelectedOption(value)}
      onChange={onChange}
      options={visibilityOptions}
      formatOptionLabel={(option, { context }) => {
        // When closed (showing selected value), show abbreviated code
        if (context === 'value') {
          return option.abbreviation || option.label;
        }
        // When open (showing in menu), show full label
        return option.label;
      }}
      isSearchable={false}
      isDisabled={disabled}
      menuPlacement="auto"
      className={className || (!compact ? 'form-select-custom' : '')}
      placeholder={placeholder}
    />
  );
};

export default PortalVisibilitySelect;
